// src/services/superAdminServices/SuperAdminBlueprintService.ts
import { 
    BlueprintRoleDto, 
    BlueprintPermissionRef, 
    CreateBlueprintRequestDto, 
    UpdateBlueprintRequestDto 
} from "../../interfaces/superAdmin/SuperAdminBlueprints";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export async function getAllBlueprints(authToken: string): Promise<BlueprintRoleDto[] | null> {
    try {
        const response = await fetch(`${API_BASE_URL}/superadmin/blueprints`, {
            headers: { 'Authorization': `Bearer ${authToken}` },
        });
        if (!response.ok) throw new Error(response.statusText);
        const json = await response.json();
        return json.data; 
    } catch (error) {
        console.error("Error fetching blueprints:", error);
        return null;
    }
}

export async function getBlueprintReferenceData(authToken: string): Promise<BlueprintPermissionRef[] | null> {
    try {
        const response = await fetch(`${API_BASE_URL}/superadmin/blueprints/reference`, {
            headers: { 'Authorization': `Bearer ${authToken}` },
        });
        if (!response.ok) throw new Error(response.statusText);
        const json = await response.json();
        return json.data;
    } catch (error) {
        console.error("Error fetching blueprint reference data:", error);
        return null;
    }
}

export async function createBlueprint(authToken: string, data: CreateBlueprintRequestDto): Promise<BlueprintRoleDto | null> {
    try {
        const response = await fetch(`${API_BASE_URL}/superadmin/blueprints`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
            body: JSON.stringify(data),
        });
        if (!response.ok) throw new Error(response.statusText);
        
        const json = await response.json();
        // Safely unwrap the data array/object from the response
        if (json.data) {
            return Array.isArray(json.data) ? json.data[0] : json.data;
        }
        return json;
    } catch (error) {
        console.error("Error creating blueprint:", error);
        return null;
    }
}

export async function updateBlueprint(authToken: string, blueprintKey: string, data: UpdateBlueprintRequestDto): Promise<BlueprintRoleDto | null> {
    try {
        const response = await fetch(`${API_BASE_URL}/superadmin/blueprints/${blueprintKey}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
            body: JSON.stringify(data),
        });
        if (!response.ok) throw new Error(response.statusText);
        
        const json = await response.json();
        // Safely unwrap the data array/object from the response
        if (json.data) {
            return Array.isArray(json.data) ? json.data[0] : json.data;
        }
        return json;
    } catch (error) {
        console.error("Error updating blueprint:", error);
        return null;
    }
}

export async function deleteBlueprint(authToken: string, blueprintKey: string): Promise<boolean> {
    try {
        const response = await fetch(`${API_BASE_URL}/superadmin/blueprints/${blueprintKey}`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${authToken}` },
        });
        return response.ok;
    } catch (error) {
        console.error("Error deleting blueprint:", error);
        return false;
    }
}